var cart = new function(){

  var me = this;
  this.rentDays = 1;

  this.popup = {
    "show": function(type,data,callback){
      var template = $("#"+type).html();
      var stone = Handlebars.compile(template)(data);
      var html = $.parseHTML(stone);

      $('[data-cart-popup]').html(html);

      $('body').addClass('overlay');
      $('[data-cart-popup] .listProduct').addClass('active');

      $('#cancel').off('click');
      $('#cancel').on('click', function() {
        me.popup.hide();
      });

      $('#close').off('click');
      $('#close').on('click', function() {
        if(typeof callback !== "undefined")
          callback();
        me.popup.hide();
      });
    },
    "hide": function(){
      $('[data-cart-popup] .listProduct').removeClass('active');
      $('[data-cart-popup]').html('');
      $('body').removeClass('overlay');
    }
  };

  this.add = function(id,data){
    $.post('/cart/get',{'id':id,'_token':window.Laravel.csrfToken},function(response){
      if(parseInt(response.code) == 1)
        data.among = response.msg;

      me.popup.show('cart-among',data,function(response){
        var among = $("[data-cart-popupamong]").val();
        $.post('/cart/add',{'id':id,'among':among,'_token':window.Laravel.csrfToken},function(response){
          me.popup.show('cart-info',{msg:response.msg});
          $(".header__count--had").html(response.among);
        },"json");
      });
    });
  };

  this.remove = function(hash){
    $.post('/cart/remove',{'hash':hash,'_token':window.Laravel.csrfToken},function(response){
      me.popup.show('cart-info',{'msg':response.msg});
      if(response.code == 1){
        $(".header__count--had").html(response.among);
        $("[data-cart-remove='"+hash+"']").closest('.card__row').fadeOut(function(){
          $(this).remove();
          $(".card__resume--netto").find("strong:last").html(parseFloat(response.sum_without_tax).toFixed(2)+" zł");
          $(".card__resume--brutto").find("strong:last").html(parseFloat(response.sum_with_tax).toFixed(2)+" zł");

          if($(".card__row").length==1){
            $("[data-cart-update]").remove();
            $("[data-cart-submit]").remove();
          }
        });
        $("[data-cart-remove='"+hash+"']").closest(".orderForm__innerCardOrder--row").fadeOut(function(){
          $(this).remove();
          $(".orderForm__innerCardResume--price").html(parseFloat(response.sum_with_tax).toFixed(2)+" zł");
        });
      }
    },"json");
  };

  this.update = function(hash,operation,row){
    var value = parseInt(row.find(".digital input").val());
    value = operation>0 ? value+1 : (value>1 ? value-1 : value);
    me.updateListCallback(value,row);
  };

  this.updateListCallback = function(value,row){
    if(value>=0){
      row.find(".digital input").val(value);
      var price = parseFloat(row.find(".card__row--item.price span").html().slice(0,-3).replace(',','.'));
      row.find(".card__row--item.value span").html((price*value*me.rentDays).toFixed(2).replace('.',',') + " zł");

      var rows = $(".card__row"),sum=0;
      for(var i=1;i<rows.length;i++){
        sum+= parseFloat(rows.eq(i).find(".card__row--item.value span").html().slice(0,-3).replace(',','.'));
      }

      $(".card__resume--netto").find("strong:last").html(sum.toFixed(2).replace('.',',')+" zł");
      $(".card__resume--brutto").find("strong:last").html((sum*1.23).toFixed(2).replace('.',',')+" zł");

      /**
       * koszyk mini
       */
      var index = $("[data-cart-row]").index(row);
      $("[data-cart-rowmini]").eq(index).find("[data-cart-amongmini]").html(value);
      $("[data-cart-summini]").html((sum*1.23).toFixed(2).replace('.',',')+" zł");
    }
  };

  this.clear = function(){
    $.post('/cart/clear',{'_token':window.Laravel.csrfToken},function(response){
      location.reload();
    });
  };

  this.updatePopup = function(operation){
    var value = parseInt($("[data-cart-popupamong]").val());
    if(operation>0){
      value+=1;
    }else{
      value = value>1 ? value-1 : value;
    }
    $("[data-cart-popupamong]").val(value);
  }

  this.changeDeliveryOption = function(deliveryType){
    if(deliveryType=='personal'){
      $("[data-deliverytype='personal']").fadeOut();
      $("[data-deliverytitle-date]").html("Data odbioru");
      $("[data-deliverytitle-time]").html("Godzina odbioru");
      $("[data-deliverytype='personal']").removeClass("tyledForm__row--requried");
      $("[data-deliverytype='personal'] input").removeAttr("required");
    }else{
      $("[data-deliverytype='personal']").fadeIn();
      $("[data-deliverytitle-date]").html("Data dostawy");
      $("[data-deliverytitle-time]").html("Godzina dostawy");
      $("[data-deliverytype='personal']").addClass("tyledForm__row--requried");
      $("[data-deliverytype='personal'] input").attr("required","required");
    }
  };

  this.tab = {
    "current": 1,
    "next": function(){
      if(me.tab.current < 2){
        $("[data-cart-tab='"+me.tab.current+"']").fadeOut(function(){
          me.tab.current++;
          // $("[data-cart-tab='"+me.tab.current+"'] .formOrder").css({
          //   'opacity': 1,
          //   'height': 'auto',
          //   'visibility':'visible'
          // });
          $("[data-cart-tab='"+me.tab.current+"']").fadeIn();
          me.tab.setActive();
          me.tab.setHeader();
        });
      }
    },
    "previous": function(){
      if(me.tab.current > 1){
        $("[data-cart-tab='"+me.tab.current+"']").fadeOut(function(){
          me.tab.current--;
          $("[data-cart-tab='"+me.tab.current+"']").fadeIn();
          me.tab.setActive();
          me.tab.setHeader();
        });
      }
    },
    "setActive": function(){
      $(".steps__numbers span.active").removeClass('active');
      $(".steps__numbers span:eq("+(me.tab.current-1)+")").addClass('active');
    },
    "setHeader": function(){
      var header = "";
      switch(me.tab.current){
        case 1: header = "Mój koszyk"; break;
        case 2: header = "Formularz zamówienia"; break;
      }
      $(".mainContainer__mainTitle").fadeOut(function(){
        $(this).html(header);
        $(this).fadeIn();
      });
    },
    "bindEvents": function(){
      // $("[data-cart-tabnext]").bind('click',function(e){
      //   me.tab.next();
      //   return false;
      // });
      $("[data-cart-tabprevious]").bind('click',function(){
        me.tab.previous();
        return false;
      });
    }
  };

  this.updateRequest = function(){
    $.post('/cart/update',{'_token':window.Laravel.csrfToken,'form':$('#cartList').serialize()},function(){
      me.tab.next();
    });
  };

  this.validateNumber = function(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode === 8 || event.keyCode === 46) {
        return true;
    } else if ( key < 48 || key > 57 ) {
        return false;
    } else {
        return true;
    }
  };

  this.calcDateDiff = function(d1,d2){
    /*if(d1!='' && d2!=''){
      d1 = d1.split('.').reverse().join('/');
      d2 = d2.split('.').reverse().join('/');
      d1 = Date.parse(d1);
      d2 = Date.parse(d2);
      if(!isNaN(d2) && !isNaN(d1) && d2 >= d1){
        var diff = d2 - d1;
        me.rentDays = diff/(24*3600*1000) + 1;
        $("[data-cart-listamong]").eq(0).trigger('change');
      }
    }*/
  };

  this.checkRentDates = function(d1,d2){
    if(d1!='' && d2!=''){
      d1 = d1.split('.').reverse().join('/');
      d2 = d2.split('.').reverse().join('/');
      d1 = Date.parse(d1);
      d2 = Date.parse(d2);
      if(!isNaN(d2) && !isNaN(d1) && d2 >= d1){
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  };

  this.bindEvents = function(){
    $("[data-cart-add]").bind('click',function(){
      me.add($(this).attr("data-cart-id"),{
        'img': $(this).closest('.offerList__box').find('img').attr('src'),
        'title': $(this).closest('.offerList__box').find('.offerList__boxHeadings--model').html()
      });
      return false;
    });

    $("[data-cart-remove]").bind('click',function(){
      var hash = $(this).attr("data-cart-remove");
      me.popup.show('cart-confirm',{'question':'Czy chcesz usunąć produkt z koszyka?'},function(){
        me.remove(hash);
      });
      return false;
    });

    $("[data-cart-clear]").bind('click',function(){
      me.popup.show('cart-confirm',{'question':'Czy chcesz usunąć wszystkie produkty z koszyka?'},function(){
          me.clear();
      });
      return false;
    });

    $("[data-cart-amongplus]").bind("click",function(){
      me.update($(this).attr('data-cart-hash'),1,$(this).closest('[data-cart-row]'));
      return false;
    });

    $("[data-cart-amongminus]").bind("click",function(){
      me.update($(this).attr('data-cart-hash'),-1,$(this).closest('[data-cart-row]'));
      return false;
    });

    $("body").on("click","[data-cart-popupamongplus]",function(){
      me.updatePopup(1);
      return false;
    });

    $("body").on("click","[data-cart-popupamongminus]",function(){
      me.updatePopup(-1);
      return false;
    });

    $("body").on("change","[data-cart-popupamong]",function(){
      var value = $(this).val();
      if(value == 0)
        $(this).val($(this).attr('data-oldvalue'));
      else
        $(this).attr('data-oldvalue',value);
    });

    $('[data-cart-update]').bind('click',function(){
      if($(".orderForm__innerCardOrder--row").length>0){
        me.updateRequest();
      }
      return false;
    });

    // $("#cartOrder").bind('submit',function(){
    //   return false;
    // });

    $("#cartOrder input[name='reception']").bind('click',function(){
      me.changeDeliveryOption($(this).val());
    });

    $("body").on("keypress","[data-cart-listamong]",me.validateNumber);

    $("[data-cart-listamong]").bind("change",function(){
      var value = $(this).val();
      if(value == 0)
        value = $(this).attr('data-oldvalue');
      else
        $(this).attr('data-oldvalue',value);
      me.updateListCallback(value,$(this).closest('[data-cart-row]'));
    });

    $("input[name='fromLease']").bind('change',function(){
      $(".orderForm__innerCardOrderDate--from").html($(this).val());
      me.calcDateDiff($("input[name='fromLease']").val(),$("input[name='toLease']").val());
    });

    $("input[name='toLease']").bind('change',function(){
      $(".orderForm__innerCardOrderDate--to").html($(this).val());
      me.calcDateDiff($("input[name='fromLease']").val(),$("input[name='toLease']").val());
    });


    $("#cartOrder").bind("submit",function(){
      if($(this).valid()){
        var result = me.checkRentDates($("input[name='fromLease']").val(),$("input[name='toLease']").val());
        if(!result){
          me.popup.show('cart-info',{msg:"Początkowy czas wynajmu musi być mniejszy lub równy końcowemu"});
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    });

    $("input[name='hours']").bind("keyup",function(){
      var value = $(this).val();
      if(value.length == 2 && parseInt(value)>=0 && parseInt(value)<=24)
        $("input[name='minutes']").focus();
    });

    me.tab.bindEvents();
  };
};

$(document).ready(function(){
  cart.bindEvents();
});
